import Vue from 'vue'
import Vuex from 'vuex'
import projects from './modules/projects'
import expenses from './modules/expenses'
import suppliers from './modules/suppliers'
import users from './modules/users'
import roles from './modules/roles'
import cost_codes from './modules/cost_codes'
import invoices from './modules/invoices'
import attendances from './modules/attendances'
import employees from './modules/employees'
import { app_usage, expense_summary, attendance_summary } from './modules/dashboard'
import { summary_expenses, summary_invoices, summary_cost_codes, summary_attendances, summary_labour } from './modules/summary'
import staff from './modules/staff'
import notifications from './modules/notifications'

// Make sure to call Vue.use(Vuex)
Vue.use(Vuex)

// Define store and initialize vuex store
const store = new Vuex.Store({
  modules: {
    projects,
    expenses,
    suppliers,
    users,
    roles,
    cost_codes,
    invoices,
    attendances,
    employees,
    app_usage,
    expense_summary,
    attendance_summary,
    summary_expenses,
    summary_invoices,
    summary_cost_codes,
    summary_attendances,
    summary_labour,
    staff,
    notifications
  }
})

// Export {store}
export default store
